module.exports = __webpack_public_path__ + "img/img_loading_logo@3x.1b0a5dc1.png";